'use client';

import styles from './FullImage.module.scss'
import useProgressiveImg from '@/hooks/useProgressiveImg';

const FullImage = ({className='', image = ''}) => {
  const [src, { blur }] = useProgressiveImg(image.replace('-lg', '-sm'), image);
  return (
    <div className={styles["full-image"]}>
      <picture>
        <img
          src={src}
          style={{
            filter: blur ? "blur(20px)" : "none",
            transition: blur ? "none" : "filter 0.3s ease-out",
          }}
          loading="lazy"
        />
      </picture>
    </div>
  );
}

export default FullImage
